<template>
	<!-- 排号屏手机版本 -->
	<div class="wrap" v-if="!repair">
		<div class="time">
			<span>
				当前时间:{{time}}
			</span>
			<span>
				景区日最大承载量：{{maxNumber}}
			</span>
		</div>
		
		<div class="area">
			<div class="area-address">
				{{config.companyName}}
				<span>{{self.projectName}}</span> 
				（{{selfAdd||self.projectRemark}}）
			</div>
			<!-- 需要排号 -->
			<div class="area-number" v-if="sceneSortStatus==1">
				<p>{{self.autoTitle}}</p>
				<p>{{self.showStart}}-{{self.showEnd}}</p>
			</div>
			
			<div class="area-time">
				<!-- 不排号 -->
				<template v-if="sceneSortStatus==0&&selfTimeList.length>0">
					<p >
						候乘区时段 
						<span style="color: #ff0000;">{{selfTimeList[0].batchDateFrom.substr(10,6)}}-{{selfTimeList[0].batchDateTo.substr(10,6)}}</span>
					</p>
					<p v-if="self.sortDisplay&&self.sortDisplay.display">
						乘坐序号
						<span style="color: #ff0000;">{{self.sortDisplay.display}}</span>
					</p>
					<p>本时段余票 <span>{{selfTimeList[0].batchDisplayHasNum}}</span> 张</p>
					<p v-if="selfTimeList.length>1">下一时段余票 <span>{{selfTimeList[1].batchDisplayHasNum}}</span> 张</p>
					<p>今日余票 <span>{{selfTotal}}</span> 张</p>
				</template>
				
				<!-- 排号 -->
				<template v-if="sceneSortStatus==1">
					<p>今日余票：{{self.batchHasNum}}</p>
					<p v-if="config2.showNumberToPhone=='1'">已排号至：{{self.sortTotalCapacity}}</p>
					<p v-if="config2.showEntryTimePhone=='1'">预计排队进入时间：{{self.sortTotalTime}}</p>
				</template>
			</div>
		</div>
		
		<div class="area">
			<div class="area-address">
				{{config.companyName}}
				<span>{{other.projectName}}</span> 
				（{{otherAdd||other.projectRemark}}）
			</div>
			<!-- 需要排号 -->
			<div class="area-number" v-if="sceneSortStatus==1">
				<p>{{other.autoTitle}}</p>
				<p>{{other.showStart}}-{{other.showEnd}}</p>
			</div>
			
			<div class="area-time">
				<!-- 不排号 -->
				<template v-if="sceneSortStatus==0&&otherTimeList.length>0">
					<p >
						候乘区时段 
						<span style="color: #ff0000;">{{otherTimeList[0].batchDateFrom.substr(10,6)}}-{{otherTimeList[0].batchDateTo.substr(10,6)}}</span>
					</p>
					<p v-if="other.sortDisplay&&other.sortDisplay.display">
						乘坐序号
						<span style="color: #ff0000;">{{other.sortDisplay.display}}</span>
					</p>
					<p>本时段余票 <span>{{otherTimeList[0].batchDisplayHasNum}}</span> 张</p>
					<p v-if="otherTimeList.length>1">下一时段余票 <span>{{otherTimeList[1].batchDisplayHasNum}}</span> 张</p>
					<p>今日余票 <span>{{otherTotal}}</span> 张</p>
				</template>
				
				<!-- 排号 -->
				<template v-if="sceneSortStatus==1">
					<p>今日余票：{{other.batchHasNum}}</p>
					<p v-if="config2.showNumberToPhone=='1'">已排号至：{{other.sortTotalCapacity}}</p>
					<p v-if="config2.showEntryTimePhone=='1'">预计排队进入时间：{{other.sortTotalTime}}</p>
				</template>
			</div>
		</div>
		
		<div class="tips" v-html="screenTipPhone">
		</div>
		
		<div v-if="errMsg" style="margin-top: 2vh;color: #ff0000;">
			错误提示：{{errMsg}}
		</div>
	</div>
	<!-- 设备维修中 -->
	<div class="wrap" v-else style="text-align: center;padding-top:300px;font-size:30px;color:#ffffff;">
		维修中...
	</div>
</template>

<script setup>
import { ref,onUnmounted,onMounted} from 'vue'
import $request from '../assets/js/request.js'
//---获取排队信息
let config=''
let config2=''
let token=''
if(sessionStorage.config){
  config=JSON.parse(sessionStorage.config)//登录缓存的本地信息
  token=config.token
  config2=config.config
  if(config2.showEntryTimePhone){
    config2.showEntryTimePhone=parseInt(config2.showEntryTimePhone)
  }
  if(config2.showNumberToPhone){
    config2.showNumberToPhone=parseInt(config2.showNumberToPhone)
  }
  if(config2.showScanningCode){
    config2.showScanningCode=parseInt(config2.showScanningCode)
  }
}
let timer=''
let errMsg=ref('')
let maxNumber=ref(0)//最大购买数量
let screenTipPhone=ref('')//配置信息
let self=ref({})//本站点信息
let other=ref({})//其他站点信息
let selfAdd=ref('')//本站地址
let otherAdd=ref('')//对面地址
let sceneSortStatus=ref('')//排号是否上下架
let selfTimeList=ref([])//本站时段列表
let otherTimeList=ref([])//对岸时段列表
let selfTotal=ref(0)//本站总库存
let otherTotal=ref(0)//对面总库存
let dataTimer=''//时间函数
let repair=ref(false)

//---数据初始化
let data={
  companyId:config.companyId,
	batchIndex:0
}
function getSort(){
  $request('tbd-product/sort/scene/batchQuery?token='+token, data).then((res) => {
		try {
			repair.value=false
			if (res.code == '00') {
			  let sortInfo=res.data||[]
				//获取南北站总体数据
				let newArr=[]
				sortInfo.forEach(item=>{
					//等于-1为南北站总的数据
					if(item.batchIndex==-1){
						newArr.push(item)
					}
				})
			  //站点Id
			  let projectId1=newArr[0].projectId
			  let projectId2=newArr[1].projectId
			  screenTipPhone.value=res.main[projectId1].projectExtend.screenTipPhone||''
			  selfAdd.value=res.main[projectId1].projectExtend.projectAddress||''
			  otherAdd.value=res.main[projectId2].projectExtend.projectAddress||''
			  sceneSortStatus.value=res.main[projectId1].sceneSortStatus
			  maxNumber=0
			  newArr.forEach(item=>{
			    maxNumber+=item.batchDisplayNum
			    item.autoTitle = item.showEnd >= item.sortTotalCapacity ? '请进入等候区' : '正进入验号区号段'
			    item.color = item.showEnd >= item.sortTotalCapacity ? '#ff0000' : '#ffffff'
			  })
			  self.value=newArr[0]
			  other.value=newArr[1]
				//获取南北站分时段数据
				selfTimeList.value=[]
				otherTimeList.value=[]
				selfTotal.value=0
				otherTotal.value=0
				sortInfo.forEach(item=>{
					//不等于-1为各个时段分时段数据
					if(item.batchIndex!=-1){
						if(item.projectId==projectId1){
							selfTimeList.value.push(item)
							selfTotal.value+=item.batchDisplayHasNum
						}
						if(item.projectId==projectId2){
							otherTimeList.value.push(item)
							otherTotal.value+=item.batchDisplayHasNum
						}
					}
				})
				dataTimer=setTimeout(getSort,1000*30)
			}else{
			  errMsg.value=res.message
				dataTimer=setTimeout(getSort,1000*30)
			} 	
		} catch (error) {
			//停运检修时获取不到数据，一分钟去请求一次
			dataTimer=setTimeout(getSort,1000*60)
			repair.value=true
		}
  }).catch(()=>{
    errMsg.value='请求失败'
		dataTimer=setTimeout(getSort,1000*30)
  })
}

//---获取时间
let time=ref('') //倒计时
function getTime() {
  time.value=new Date().Format('hh:mm:ss')
  setTimeout(getTime, 1000)
}
onMounted(()=>{
	getTime()
	getSort()
})
//---页面销毁的时候
onUnmounted(()=>{
	// 清除定时器，避免内存泄漏
	if (dataTimer) {
		clearTimeout(dataTimer)
	}
})
</script>

<style lang="scss" scoped>
	.wrap{
		min-height: 100%;
		background:url('../assets/image/suodao.jpg') no-repeat;
		font-size: 14px;
		padding: 3vh 16px;
		background-size: 100% 100%;
	}
	.time{
		background: #ffffff;
		border-radius: 10px;
		padding:20px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.area{
		margin-top: 2.5vh;
		background: #ffffff;
		border-radius: 10px;
		padding: 16px 20px;
	}
	.area-address{
		font-weight: bold;
		span{
			color: #ff0000;
			font-size: 16px;
		}
	}
	.area-number{
		font-weight: bold;
		font-size: 16px;
		text-align: center;
		margin-top: 4vh;
		color: #ff0000;
		p:last-child{
			font-size: 30px;
		}
	}
	.area-time{
		margin-top: 2.5vh;
		p:not(:first-child){
			margin-top: 10px;
		}
	}
	.tips{
		margin-top: 3vh;
		line-height: 28px;
		color: #ffffff;
	}
</style>